import React, { cloneElement } from 'react';
import {
  List,
  Datagrid,
  TextField,
  SelectField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  LongTextInput,
  RefreshButton,
  EditButton,
  ImageInput,
  ImageField,
  SelectInput,
  Show,
  ShowButton,
  TabbedShowLayout,
  Tab,
  //ReferenceField,
  RichTextField,
  DateField,
  CardActions,
  CreateButton,
  Filter,
  Responsive,
  SimpleList,
  translate,
  resolveBrowserLocale,
  FunctionField,
  DeleteButton,
  ListButton,
  SaveButton,
  Toolbar
  //ListController,
  //ListView
  // Labeled,
} from 'react-admin';
import { Title } from '../components/Title';
import RichTextInput from 'ra-input-rich-text';
import { DateTimeInput } from 'react-admin-date-inputs';
import { withStyles } from '@material-ui/core/styles';
// import moment from 'moment';
// import { PageTitle } from './common';
import { ContributionTab } from '../contributions/ContributionTab';
import { Pagination } from 'react-admin';

const PostPagination = props => (
  <Pagination rowsPerPageOptions={[]} {...props} />
);
const paginationMission = 50;

const styles = theme => ({
  hiddenOnMediumScreens: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  image: {
    width: 'auto',
    height: '100%',
    maxHeight: '3rem',
    objectFit: 'cover'
  }
});

const MissionsFilter = props => (
  <Filter {...props}>
    <TextInput label="Rechercher" source="searchQuery" alwaysOn />
  </Filter>
);

// const MissionTitle = ({ record }) => (
//   <span>Mission : {record ? `"${record.title}"` : ''}</span>
// );

const MissionsListActions = ({
  basePath,
  data,
  resource,
  filters,
  showFilter,
  displayedFilters,
  filterValues,
  roleLevel,
  ...rest
}) => {
  return (
    <CardActions>
      {roleLevel > 0 && <CreateButton basePath={basePath} />}
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
      <RefreshButton />
    </CardActions>
  );
};

let MissionsList = props => {
  const locales = resolveBrowserLocale();
  const { translate, classes, options, ...rest } = props;
  const { roleLevel } = options;

  return (
    <List
      title={<Title />}
      actions={
        <MissionsListActions roleLevel={roleLevel} translate={translate} />
      }
      bulkActionButtons={false}
      perPage={paginationMission}
      //title={<PageTitle title={translate('resources.missions.name', 2)} />}
      //actions={<MissionsListActions />}
      sort={{ field: 'startDate', order: 'ASC' }}
      {...rest}
      pagination={<PostPagination />}
      filters={<MissionsFilter />}
      //pagination={null}
      //sortable={false}
    >
      <Responsive
        xsmall={
          <SimpleList
            primaryText={record => record.title}
            secondaryText={record => (
              <SelectField
                record={record}
                source="state"
                sortable={false}
                choices={[
                  { id: 'complished', name: 'complished' },
                  { id: 'available', name: 'available' },
                  { id: 'aborted', name: 'aborted' },
                  { id: 'draft', name: 'draft' }
                ]}
              />
            )}
            tertiaryText={record => (
              <DateField
                source="startDate"
                //sortable={false}
                locales={locales}
                showTime
                record={record}
              />
            )}
            leftAvatar={record => (
              <ImageField
                classes={classes}
                source="pic_thumbnail.src"
                title="thumbnail image"
                record={record}
              />
            )}
            linkType="show"
          />
        }
        large={
          <Datagrid>
            <TextField
              source="title"
              //sortable={false}
            />
            <ImageField
              classes={classes}
              sortable={false}
              headerClassName={classes.hiddenOnMediumScreens}
              cellClassName={classes.hiddenOnMediumScreens}
              source="pic_thumbnail.src"
              title="pic_thumbnail.title"
              label="image_thumbnail"
            />
            <DateField
              source="startDate"
              //sortable={false}
              locales={locales}
              options={{
                weekday: 'long',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
              }}
            />
            <DateField
              source="endDate"
              //sortable={false}
              locales={locales}
              options={{
                weekday: 'long',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
              }}
              headerClassName={classes.hiddenOnMediumScreens}
              cellClassName={classes.hiddenOnMediumScreens}
            />
            <TextField
              source="location"
              //sortable={false}
            />
            <SelectField
              source="state"
              sortable={false}
              choices={[
                { id: 'complished', name: 'complished' },
                { id: 'available', name: 'available' },
                { id: 'aborted', name: 'aborted' },
                { id: 'draft', name: 'draft' }
              ]}
            />
            <ShowButton />
            {roleLevel > 0 && <EditButton />}
          </Datagrid>
        }
      />
    </List>
  );
};

const MissionShowActions = ({ basePath, data, roleLevel, resource }) => {
  return (
    <CardActions>
      {roleLevel > 0 && <EditButton basePath={basePath} record={data} />}
      {roleLevel > 1 && (
        <DeleteButton basePath={basePath} resource={resource} record={data} />
      )}

      <ListButton basePath={basePath} />
      <RefreshButton />
    </CardActions>
  );
};

const renderContributions = ({ record }) => {
  Object.size = function(obj) {
    var size = 0,
      key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++;
    }
    return size;
  };

  return Object.size(record.contributions && record.contributions);
};

let MissionShow = ({ translate, options, ...props }) => {
  const { hasList, hasCreate, hasShow, hasEdit, resource, ...rest } = props;
  const { roleLevel } = options;

  return (
    <Show
      title={<Title />}
      // title={<MissionTitle />}
      actions={<MissionShowActions resource={resource} roleLevel={roleLevel} />}
      {...props}
    >
      <TabbedShowLayout>
        <Tab label={translate('resources.missions.details')}>
          <TextField source="title" />
          <TextField source="subtitle" />
          <SelectField
            source="state"
            choices={[
              { id: 'complished', name: 'complished' },
              { id: 'available', name: 'available' },
              { id: 'aborted', name: 'aborted' },
              { id: 'draft', name: 'draft' }
            ]}
          />
          <FunctionField
            label={translate('resources.contributions.name', 2)}
            render={record => renderContributions({ record })}
          />
          <TextField source="location" />
          <DateField source="startDate" showTime />
          <DateField source="endDate" showTime />
          <RichTextField source="description" />
          <ImageField source="pic_thumbnail.src" title="thumbnail image" />
          <ImageField source="pic_cover.src" title="cover image" />
        </Tab>
        <Tab label={translate('resources.contributions.name', 2)}>
          <ContributionTab roleLevel={roleLevel} {...rest} />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

let CustomDateInput = props => {
  const { source, label } = props;
  // const timeStamp = moment(Date.now()).format('DD/MM/YYYY HH:mm');
  // console.log(timeStamp);
  return (
    <DateTimeInput
      source={source}
      label={label}
      options={{ format: 'dd/MM/YYYY HH:mm', ampm: false, clearable: true }}
    />
  );
};

const MissionsEditActions = ({ basePath, data, roleLevel, resource }) => {
  return (
    <CardActions>
      <ShowButton basePath={basePath} record={data} />
      <ListButton basePath={basePath} />
      <RefreshButton />
      {roleLevel > 1 && (
        <DeleteButton basePath={basePath} resource={resource} record={data} />
      )}
    </CardActions>
  );
};

const MissionEditToolbar = ({ record, ...rest }) => {
  return (
    <Toolbar {...rest}>
      <SaveButton label="ENREGISTRER" redirect="show" submitOnEnter={true} />
    </Toolbar>
  );
};

let MissionEdit = props => {
  const { translate, resource, options } = props;
  const { roleLevel } = options;

  return (
    <Edit
      title={<Title />}
      //title={<MissionTitle />}
      actions={
        <MissionsEditActions resource={resource} roleLevel={roleLevel} />
      }
      {...props}
    >
      <SimpleForm redirect="list" toolbar={<MissionEditToolbar />}>
        {/* <DateInput source="creationTime" disabled /> */}
        <TextInput source="title" />
        <LongTextInput source="subtitle" />
        <SelectInput
          source="state"
          choices={[
            { id: 'complished', name: 'complished' },
            { id: 'available', name: 'available' },
            { id: 'aborted', name: 'aborted' },
            { id: 'draft', name: 'draft' }
          ]}
        />
        <TextInput source="location" />
        <CustomDateInput
          source="startDate"
          label="resources.missions.fields.startDate"
        />
        <CustomDateInput
          source="endDate"
          label="resources.missions.fields.endDate"
        />
        <RichTextInput source="description" />
        <ImageInput
          multiple={false}
          source="pic_thumbnail"
          label="image_thumbnail"
          accept="image/*"
          placeholder={<p>{translate('drop_thumbnail_here')}</p>}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
        <ImageInput
          multiple={false}
          source="pic_cover"
          label="image_cover"
          accept="image/*"
          placeholder={<p>{translate('drop_image_here')}</p>}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

let MissionCreate = props => {
  const { translate } = props;
  return (
    <Create {...props}>
      <SimpleForm redirect="list">
        <TextInput source="title" required />
        <LongTextInput source="subtitle" />
        <SelectInput
          source="state"
          choices={[
            { id: 'complished', name: 'complished' },
            { id: 'available', name: 'available' },
            { id: 'aborted', name: 'aborted' },
            { id: 'draft', name: 'draft' }
          ]}
        />
        <TextInput source="location" />
        <CustomDateInput
          source="startDate"
          label="resources.missions.fields.startDate"
        />
        <CustomDateInput
          source="endDate"
          label="resources.missions.fields.endDate"
        />
        <RichTextInput
          source="description"
          // toolbar={[['bold', 'italic', 'underline', 'link']]}
        />
        <ImageInput
          multiple={false}
          source="pic_thumbnail"
          label="image_thumbnail"
          accept="image/*"
          placeholder={<p>{translate('drop_thumbnail_here')}</p>}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
        <ImageInput
          multiple={false}
          source="pic_cover"
          label="image_cover"
          accept="image/*"
          placeholder={<p>{translate('drop_image_here')}</p>}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
};

MissionsList = translate(MissionsList);
MissionsList = withStyles(styles)(MissionsList);
MissionCreate = translate(MissionCreate);
MissionShow = translate(MissionShow);
MissionEdit = translate(MissionEdit);
//ContributionTab = translate(ContributionTab);
// ContributionsGrid = translate(ContributionsGrid);
export { MissionsList, MissionCreate, MissionShow, MissionEdit };



// WEBPACK FOOTER //
// ./src/components/Missions.js